class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      if(this.closest('[data-cart-group]')) {
        const updatesData = this.closest('[data-cart-group]').dataset.cartGroup;
        this.closest('cart-drawer').updateQuantity(this.dataset.index, 0, null, 'update', updatesData);
      }else{
        this.closest('cart-drawer').updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Elements
    this.drawer = document.getElementById('cart-drawer');
    
    this.cartButton = document.querySelector('.js-open-cart');
    this.cartButton.addEventListener('click', this.handleCartClick.bind(this));

    this.closeIcon = document.getElementById('cart-drawer__close');
    this.closeIcon.addEventListener('click', this.close.bind(this));
    
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.pageOverlayElement = document.querySelector('.page-overlay');

    // this.checkoutBtn = document.querySelector("a[href='/checkout']");
    // this.checkoutBtn.addEventListener('click', window.location = '/checkout');

    // Functionality
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  open() {
    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.add('is-visible');
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.remove('is-visible');
    document.body.removeEventListener('click', this.onBodyClick);
  }

  onChange(event) {
    if(event.target.closest('[data-cart-group]') && event.target.value == 0) {
      const updatesData = event.target.closest('[data-cart-group]').dataset.cartGroup;
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'),'update', updatesData);
    }else{
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
  }

  updateQuantity(line, quantity, name, action = null, updateData = null) {
    const diagnostic = { surface: 'drawer', groupId: action === 'update' ? updateData : undefined };
    const operationId = Number(quantity) === 0
      ? window.FreshsendsCartDiagnostics?.('cart_remove_started', diagnostic) : undefined;
    diagnostic.operationId = operationId;
    let diagnosticBefore;
    let diagnosticDone = false;
    let diagnosticReason = 'network_error';
    this.enableLoading(line);
    let body = null;
    let giftProductSlider = document.querySelector('.gift__product--slider');
    if(giftProductSlider){
      body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRenderUpdate().map((section) => section.section),
        sections_url: window.location.pathname
      });
    }else{
      body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
    }
    // let body = JSON.stringify({
    //   line,
    //   quantity,
    //   sections: this.getSectionsToRender().map((section) => section.section),
    //   sections_url: window.location.pathname
    // });

    let fetchUrl = routes.cart_change_url;
    if(action == 'update'){
      fetchUrl = routes.cart_update_url;
      let update = {};
      update.sections = this.getSectionsToRender().map((section) => section.section);
      update.sections_url = window.location.pathname;
      update.updates = updateData;
      body = JSON.stringify(update);
    }
 
    Promise.resolve().then(async () => {
      if (action === 'update') {
        // Line keys change after edits. Resolve this gift from the current cart.
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, { cache: 'no-store' });
        diagnostic.httpStatus = response.status;
        diagnosticReason = response.ok ? 'invalid_response' : 'http_error';
        if (!response.ok) throw new Error('Unable to load cart');
        const cart = await response.json();
        diagnosticBefore = cart;
        const group = updateData;
        const parents = cart.items.filter(item => String(item.properties?._main_product ?? '') === group);
        if (!group || parents.length !== 1) {
          diagnosticDone = true;
          window.FreshsendsCartDiagnostics?.('cart_remove_aborted', { ...diagnostic, reason: 'missing_group' }, cart);
          window.location.reload();
          return;
        }
        const update = JSON.parse(body);
        update.updates = Object.fromEntries(cart.items.filter(item =>
          item.key === parents[0].key ||
          String(item.properties?._uniq_id ?? '') === group ||
          String(item.properties?._uniq_var_id ?? '') === group
        ).map(item => [item.key, 0]));
        body = JSON.stringify(update);
        diagnostic.removalKeys = Object.keys(update.updates);
      }
      diagnosticReason = 'network_error';
      delete diagnostic.httpStatus;
      return fetch(`${fetchUrl}`, {...fetchConfig(), ...{ body }});
    })
      .then((response) => {
        if (!response) return null;
        diagnostic.httpStatus = response.status;
        diagnosticReason = response.ok ? 'invalid_response' : 'http_error';
        if (!response.ok) throw new Error('Unable to update cart');
        return response.text();
      })
      .then((state) => {
        if (state === null) return;
        const parsedState = JSON.parse(state);
        diagnosticDone = true;
        if (Number(quantity) === 0) {
          window.FreshsendsCartDiagnostics?.(parsedState.status ? 'cart_remove_failed' : 'cart_remove_succeeded',
            { ...diagnostic, reason: parsedState.status ? 'http_error' : undefined }, diagnosticBefore, parsedState);
        }
        
        //cart check fresh sets or flowers
          /*fetch('/cart.js')
            .then(response => response.json())
            .then(cartData => {
                var setsproductcount = 0;
                var flowerCount = 0;
                const cartItems = cartData.items;
                cartItems.forEach(item => {
                const { product_id, title, price, quantity, handle } = item;
                if(handle == 'the-fresh-set' || handle == 'the-candle' || handle == 'the-perfume' || handle == 'the-hand-cream'){
                  setsproductcount++;
                }
                if(handle == 'the-send' || handle == 'tulips' || handle == 'roses' || handle == 'lilies'){
                  flowerCount++;
                }
                })
                document.querySelectorAll('.product__list-container .product-grid__item').forEach((item) => {
                  let findButton = item.querySelector('product-form button'),
                      findCollectionSingle = findButton.getAttribute('collection-collectionsingle'),
                      findCollectionFreshset = findButton.getAttribute('collection-collectionfreshset'),
                      findCollectionFlowers = findButton.getAttribute('collection-collectionflowers')
                  if(setsproductcount > 0 && findCollectionSingle == 'false' && findCollectionFreshset == 'false'){
                    findButton.setAttribute('disabled','disabled')
                  }else{
                    if(!findButton.hasAttribute('sold-out')) findButton.removeAttribute('disabled','disabled')
                  }
                if(flowerCount > 0 && findCollectionFlowers == 'false'){
                    findButton.setAttribute('disabled','disabled')
                  }else{
                   if(!findButton.hasAttribute('sold-out')) findButton.removeAttribute('disabled','disabled')
                  }
                })
            })
            .catch(error => {
              console.log('Error fetching cart data:', error);
            });*/
          //cart check fresh sets or flowers

          let thisData = this;
          let giftProductSlider = document.querySelector('.gift__product--slider');
          if(giftProductSlider){
            thisData.getSectionsToRenderUpdate().forEach((section => {
              const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                
              elementToReplace.innerHTML = thisData.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }));
            new Swiper('.gift__product--slider', {
              slidesPerView: 2.5,
              freeMode: true,
              loop: true,
              spaceBetween: 18,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },    
              breakpoints: {
                768: {
                  slidesPerView: 3.9,
                  freeMode: true,
                  loop: true,
                  spaceBetween: 18,
                }
              }
            });
            popupToggleListener();
          }else{
            thisData.getSectionsToRender().forEach((section => {
              const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                
              elementToReplace.innerHTML = thisData.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }));
          }
          // this.getSectionsToRender().forEach((section => {
          //   const elementToReplace =
          //   document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              
          //   elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
  
          // }));
        window.updateCartAttribute();
        this.disableLoading();
      }).catch(() => {
        if (Number(quantity) === 0 && !diagnosticDone) {
          window.FreshsendsCartDiagnostics?.('cart_remove_failed', { ...diagnostic, reason: diagnosticReason }, diagnosticBefore);
        }
        this.disableLoading();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionsToRenderUpdate() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'gift__product--wrap',
        section: document.getElementById('product__send--fs')?.dataset.id,
        selector: '.gift__product--wrap'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    getCartUpdateCheckout();
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
   if(document.getElementById('cart-drawer-loading')) document.getElementById('cart-drawer-loading').classList.remove('hidden');
  }

  disableLoading() {
   if(document.getElementById('cart-drawer-loading')) document.getElementById('cart-drawer-loading').classList.add('hidden');
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains('page-overlay')) {
      this.close();
      this.pageOverlayElement.classList.remove('is-visible');
    }
  }

  handleCartClick(evt) {
    evt.preventDefault();
    this.open();
  }
}

customElements.define('cart-drawer', CartDrawer);
